import React, { useState, useEffect } from 'react';
import axios from '../../../axiosConfig';

import { useParams, useNavigate } from 'react-router-dom';
import { Card, ListGroup, Button } from 'react-bootstrap';
import './ShowMorePagos.css';
import moment from 'moment';
import { useLoading } from '../../../components/LoadingContext';



const ShowMorePagos = ({ onReload }) => {
  const { setLoading } = useLoading();
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    

    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const response = await axios.get(`/pagos/${id}`,{
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }    setLoading(false);

    };


    fetchData();
  }, [id]);

  return (
    <div className="container my-5"> {/* Añadido margen superior */}
      <div className="row justify-content-center"> {/* Centra el contenido */}
        <div className="col-lg-9 col-md-8"> {/* Ajusta el tamaño de la tarjeta */}
          <Card className="p-4 shadow"> {/* Añadido padding y sombra */}
            <h1 className="mb-4 text-center">Detalles de Pago {data.cod}</h1> {/* Centrado el título */}
            <ListGroup variant="flush">
            <ListGroup.Item>Fecha: {moment(data.fecha).format('YYYY-MM-DD')}</ListGroup.Item>
            <ListGroup.Item>Curso: {data?.informacion_inscripcion?.curso?.descripcion}</ListGroup.Item>

            <ListGroup.Item>Cedula De Identidad: {data?.informacion_inscripcion?.datos_identificacion?.cedula_identidad}</ListGroup.Item>
            <ListGroup.Item>Tipo de Pago: {data?.tipo_pago?.descripcion}</ListGroup.Item>

            <ListGroup.Item>Tasa Bcv Usada (Sist antiguo): {data.monto_tasa}</ListGroup.Item>
             <ListGroup.Item>Tasa Bcv Usada (Sist actual): {data?.tasa_bcv?.tasa}</ListGroup.Item>
            <ListGroup.Item>Monto Cancelado: {data.monto_cancelado}$ Conversión {data.conversion_cancelado} BsF </ListGroup.Item>
            <ListGroup.Item>Monto Exonerado: {data.monto_exonerado}$ Conversión {data.conversion_exonerado} BsF </ListGroup.Item>
            
            <ListGroup.Item>Monto Restante Inscripcion: {data.monto_restante_inscripcion}$ </ListGroup.Item>
            <ListGroup.Item>Monto Restante Cuota: {data.monto_restante_cuota}$ </ListGroup.Item>
             <ListGroup.Item>Comprobante: {data.numero_comprobante}</ListGroup.Item>

            <ListGroup.Item>Tipo de Moneda: {data.tipo_moneda}</ListGroup.Item>
            <ListGroup.Item>U.C: {data?.informacion_inscripcion?.curso?.descripcion}</ListGroup.Item>
            <ListGroup.Item>Comentarios: {data.comentario_cuota}</ListGroup.Item>
          </ListGroup>
          <div className="text-center mt-4">
            <Button
                variant="secondary"
                onClick={() => navigate(-1)}  
                >
                Volver
                </Button>

            </div>
        </Card>
      </div>
      
    </div>
    </div>
  );
};

export default ShowMorePagos;
